import { render, staticRenderFns } from "./AboutItems.vue?vue&type=template&id=6d733c94&"
import script from "./AboutItems.vue?vue&type=script&lang=js&"
export * from "./AboutItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports